import { Scenario } from './scenario';

export class ScenarioManualInput {
  constructor() { }
    public scenario: Scenario;
    public criCount: number;
    public criTransactionCount: number;
    public manualMonitoringHours: number;
  }
